// extracted by mini-css-extract-plugin
module.exports = {"vsCardWrap":"zT6C2","imageWrap":"yYYj5","textWrap":"aTQlg","mainText":"ObA_k","catText":"gycE5","labaleIcon":"FHxe9","vshortVideo":"Gx7Ps","isLarge":"W2MQ0","content":"l4AaH"};